import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "children", "className", "isTooltip"];
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import StyledLinkCell from './styles';
import { EmbersLink } from '../../../link';
import classnames from 'classnames';
export var TableLinkCell = function TableLinkCell(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    className = _ref.className,
    isTooltip = _ref.isTooltip,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var handleKeyup = function handleKeyup(e) {
    if (e.key === 'Enter') onClick === null || onClick === void 0 || onClick(e);
  };
  return /*#__PURE__*/React.createElement(StyledLinkCell, _extends({
    className: classnames('EmbersLinkCell', className),
    onClick: onClick,
    tabIndex: 0,
    onKeyUp: handleKeyup,
    isTooltip: isTooltip
  }, otherProps), /*#__PURE__*/React.createElement(EmbersLink, {
    tabIndex: -1
  }, children), /*#__PURE__*/React.createElement("i", {
    className: "icon-share-alt"
  }));
};